export default __webpack_public_path__ + "static/media/undraw_no_data_re_kwbl.600dc282.svg";